import { useEffect, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuthContext } from '@/hooks/use-auth-context';
import { toast } from '@/hooks/use-toast';
import SplashScreen from '@/components/SplashScreen';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function SuperadminGuard({ children }: Props) {
  const navigate = useNavigate();
  const { user, loading, authenticated } = useAuthContext();
  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!loading) {
      if (!authenticated) {
        navigate('/login', { replace: true });
        return;
      }

      if (!user?.isSuperadmin) {
        toast({
          title: 'Access Denied',
          description: 'You do not have superadmin privileges to access this page.',
          variant: 'destructive',
        });
        navigate('/new', { replace: true });
        return;
      }

      setChecked(true);
    }
  }, [authenticated, loading, navigate, user]);

  useEffect(() => {
    check();
  }, [check]);

  if (loading || !checked) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
